import searchIcon from "../assets/svg/search-icon.svg";

const SearchBar = ({ value, onChange }) => {
  return (
    <div className="">
      <div
        className="flex items-center gap-3 
                  border border-gray-200 
                  rounded-full 
                  w-[400px]
                  px-3 py-2.5
                  font-regular
                  bg-white font-omny"
      >
        <img src={searchIcon} alt="search-icon"></img>
        <input
          type="text"
          value={value}
          onChange={onChange}
          placeholder="Search"
          className="w-full outline-none text-[#626F86] 
                 placeholder-gray-400 bg-transparent mt-1"
        />
      </div>
    </div>
  );
};

export default SearchBar;
